var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SecondaryButton',{attrs:{"x-small":"","btnClass":"mr-2 rounded","icon":"mdi-eye","iconClass":""},on:{"click":function($event){return _vm.viewOrderDetails()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }